<template>
  <div class="bg">
    <div class="container">
      <div class="titleDocument">
        已有账号，<a @click="login">立即登录</a>
      </div>
      <div class="main">
        <PlateTitle
          title="忘记密码"
        />
      </div>
      <div class="steps">
        <a-steps
          :current="current"
        >
          <a-step
            title="验证账户信息"
          />
          <a-step
            title="设置新密码"
          />
          <a-step
            title="完成找回"
          />
        </a-steps>
      </div>
      <AutInfor v-if="current === 0" />
      <NewPassword v-if="current === 1" />
      <Success v-if="current === 2" />
    </div>
  </div>
</template>

<script>
import PlateTitle from '@/components/PlateTitle';
import AutInfor from './components/autInformation.vue';
import NewPassword from './components/newPassword.vue';
import Success from './components/success.vue';
export default {
  name: 'ForgotPassword',
  components: {
    PlateTitle,
    AutInfor,
    NewPassword,
    Success,
  },
  data() {
    return {
      current: 0,
    };
  },
  methods: {
    login() {
      this.$router.push({ name: 'login' });
    },
    // 下一步传值
    getCurrent(e) {
      this.current = e;
    },
  },
};
</script>
<style lang="less" scoped>
.bg {
  background-color: #F0F3F7;
  overflow: hidden;
}
.container {
  background-color: #fff;
  width: 1180px;
  min-height: 676px;
  margin: 30px auto 80px;
  position: relative;
  .titleDocument {
    position: absolute;
    top: 36px;
    right: 50px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #999999;
  }
}
.main {
  padding: 30px 50px 95px;
}
.steps {
  width: 600px;
  margin: 0 auto;
}
a{
  color: #0E52D4;
}
::v-deep .ant-steps-item-process .ant-steps-item-icon {
  background: #0E52D4 !important;
  width: 36px;
  height: 36px;
  font-size: 16px;
  font-family: Helvetica Neue-Regular, Helvetica Neue;
  font-weight: 400;
  color: #ffffff;
  text-align: center;
  line-height: 36px;
  border-color: #0E52D4;
}
::v-deep
  .ant-steps-item-process
  > .ant-steps-item-container
  > .ant-steps-item-content
  > .ant-steps-item-title {
  font-size: 16px;
  font-family: Microsoft YaHei-Bold, Microsoft YaHei;
  font-weight: bold;
  color: #333333;
  line-height: 35px;
}

::v-deep .ant-steps-item-icon {
  width: 36px;
  height: 36px;
  font-size: 16px;
  font-family: Helvetica Neue-Regular, Helvetica Neue;
  font-weight: 400;
  color: #999999;
  text-align: center;
  line-height: 36px;
}
::v-deep
  .ant-steps-item-wait
  > .ant-steps-item-container
  > .ant-steps-item-content
  > .ant-steps-item-title {
  font-size: 16px;
  font-family: Microsoft YaHei-Regular, Microsoft YaHei;
  font-weight: 400;
  color: #999999;
  line-height: 35px;
}
.time {
  font-size: 12px;
  font-family: Microsoft YaHei-Regular, Microsoft YaHei;
  font-weight: 400;
  color: #999999;
  line-height: 14px;
}
::v-deep
  .ant-steps-item-finish
  > .ant-steps-item-container
  > .ant-steps-item-content
  > .ant-steps-item-title {
  font-size: 16px;
  font-family: Microsoft YaHei-Regular, Microsoft YaHei;
  font-weight: 400;
  color: #333333;
}
::v-deep .ant-steps-item-finish .ant-steps-item-icon {
  border-color: #0E52D4;
}
::v-deep .anticon svg {
  color: #0E52D4;
}
::v-deep .ant-steps-item-wait .ant-steps-item-icon {
  border-color: #e9e9e9;
}
::v-deep .ant-steps-item-title {
  margin-left: 5px;
}
::v-deep
  .ant-steps-item-finish
  > .ant-steps-item-container
  > .ant-steps-item-content
  > .ant-steps-item-title::after {
  background-color: #0E52D4 !important;
}
</style>
